import React from 'react';
import { Theme } from '@mui/system';
import Box from '@mui/material/Box';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import Zoom from '@mui/material/Zoom';
import Fab from '@mui/material/Fab';
import { KeyboardArrowUp } from '@mui/icons-material';

export default function ScrollTop({
  children,
}: React.PropsWithChildren<unknown>): JSX.Element {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (): void => {
    const anchor = document.querySelector('#back-to-top-anchor');

    // if (event?.target?.ownerDocument?.querySelector) {
    //   anchor = event.target.ownerDocument.querySelector('#back-to-top-anchor');
    // } else {
    //   anchor = document.querySelector('#back-to-top-anchor');
    // }

    if (anchor) {
      anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <Zoom in={trigger}>
      <Box
        sx={{
          position: 'fixed',
          bottom: (theme: Theme) => theme.spacing(3),
          right: (theme: Theme) => theme.spacing(3),
        }}
        onClick={handleClick}
      >
        {children || (
          <Fab
            sx={{
              width: {
                xs: '48px',
                sm: '56px',
              },
              height: {
                xs: '48px',
                sm: '56px',
              },
            }}
            // color="primary"
            aria-label="scroll back to top"
          >
            <KeyboardArrowUp />
          </Fab>
        )}
      </Box>
    </Zoom>
  );
}
